var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0.93rem"},domProps:{"innerHTML":_vm._s(_vm.body)}})
}
var staticRenderFns = []

export { render, staticRenderFns }